import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
// Admin Context
import { useAdminDispatch, useAdminState } from 'context/AdminContext';
import { setUser } from 'context/AdminContext/actions';
import { getUser } from 'context/AdminContext/middleware';
// App Context
import { useAppDispatch } from 'context/AppContext';
// Components
import PageHeader from 'components/PageHeader';
import User from './components/User';

interface ParamProps {
  userid: string,
}

function AmendUser() {
  // Params
  const params = useParams<ParamProps>();
  const { userid } = params;
  // Admin State
  const adminDispatch = useAdminDispatch();
  const { user } = useAdminState();
  // App State
  const appDispatch = useAppDispatch();
  // State
  const [loading, setLoading] = useState(true);

  const getData = useCallback(async () => {
    await getUser({
      adminDispatch,
      appDispatch,
      userId: userid,
    });
    setLoading(false);
  }, [adminDispatch, appDispatch, userid]);

  useEffect(() => {
    getData();
    return function cleanup() {
      adminDispatch(setUser({}));
    };
  }, [adminDispatch, getData]);

  return (
    <>
      <PageHeader
        heading={`${user.firstName} ${user.lastName}`}
        loading={loading}
        subHeading={`Employee ID: ${user.userId}`}
      />
      <section>
        { !loading && (
          <User />
        )}
      </section>
    </>
  );
}

export default AmendUser;